import { render } from "./tw-toolbar.vue?vue&type=template&id=77ff3984"
import script from "./tw-toolbar.vue?vue&type=script&lang=js"
export * from "./tw-toolbar.vue?vue&type=script&lang=js"
script.render = render

export default script